// Tipificación de las imágenes
const imagenes: { [key: string]: string[] } = {
  "bata-101": [
    "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/u5tlylaan9ijr39gusrl?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/otneekeg5coz25wdyauw?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/vsltixhgnxuoxyqfe6ju?_a=BAMCkGOa0",
  ],
  "bata-102": [
    "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/ucjjj7biggwgcssjposk?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/gbbkzvccs8wcp6xebuee?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/ukpghodmz2hn4t0pii9x?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/xm2psxaf5kcqpdkkuy14?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/kf9mwpazpqsjgdav08cm?_a=BAMCkGOa0",
  ],
  "camisa-101": [
    "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/skyupyjcyfvitzxgfbs1?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/hxovzxl7rcoqzycouh5m?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/hwizlwriutuwgenjysdh?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/wixkbtn00uldw0cjaka0?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/mhi6qiarzmug364giukx?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/yfkqj7u4fhd1evrcbe9r?_a=BAMCkGOa0",

  ],
  "boligrafo-101": [
    "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/rknm1kzp9jvwuvp2msrr?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/vzczahjraumb26ygioon?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/d0whiy02tirymfuoblgh?_a=BAMCkGOa0",

  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/rrfex8mtef8vhkigp2ml?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/qiqc1ip6yvv61jcapiox?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/rlryzm8m8tsrzleqfhi8?_a=BAMCkGOa0",

  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/bd42komkpch4jqslfhvd?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/r127dvqsc9du1s6zz9cf?_a=BAMCkGOa0",

  ],
  "folder-101": [
    "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/cphheyakgdyjc6pgv93c?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/qhgavpktw9hoqpxoi28r?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/jsmxz0g8sp53kcq1ylwt?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/ia2oxm0d08ywjpvy2bje?_a=BAMCkGOa0"
  ],
  "carpeta-102": [
    "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/mc7b39gfztmbn3a4cwie?_a=BAMCkGOa0",
    "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/vrqdjzs7xsouosag4i6o?_a=BAMCkGOa0"
  ],
  "cinta-101": [
"https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/qtmesdu6nwubbyjw1qyh?_a=BAMCkGOa0" ,
"https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/nwf2pnyutxujpjjr8f1k?_a=BAMCkGOa0",
 "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/qtmesdu6nwubbyjw1qyh?_a=BAMCkGOa0",
 "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/jp1shjcukq55k86qj0f8?_a=BAMCkGOa0",
 "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/qantuwdrgr9co4227woi?_a=BAMCkGOa0",
 "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/mudkltyl82hononjrb7u?_a=BAMCkGOa0" ],

  "clip-102": [

    "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/rchebzsstsomactggf7n?_a=BAMCkGOa0",
    "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/pu7uncp9x5vktycmra2t?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/gwxntpeyhkc7gub0hkm7?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/hu8vkwsotjqkpn9owz2i?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/r0c3yc9rqnjswddrbb59?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/ofit7yxisv9zmwumfpzx?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/e7i4j1i4arxpothlntif?_a=BAMCkGOa0"

 ],
 "clip-101": [
   "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/xzi0lv2mi6ohfzj8wlxl?_a=BAMCkGOa0",
   "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/kg1hvqvfaicskzl3j6z7?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/xzi0lv2mi6ohfzj8wlxl?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/vvbrswucjvifsqtjo5ge?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/nc3gfcb906wn4gzmlaeg?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/uppnxuvwms1iu3ouwkoc?_a=BAMCkGOa0",

 ],

 "correa-101": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/liomnuccaxjqsz98uiqj?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/ag9tabnzz4jwofhk64lu?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/vcc5avwfcgcba9iqechj?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/bpxrx28eut5cozabfce1?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/uqutgfztmaijwobrffze?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/oe3befqqo5db1s27nwod?_a=BAMCkGOa0",
"https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/fmg6sl0zq8dwed3kphiq?_a=BAMCkGOa0",
"https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/nai0pma6oizfifn7rilt?_a=BAMCkGOa0",
"https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/h0i0wewnb8a9nwimvrsj?_a=BAMCkGOa0"
 ],

 "estuche-101": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/shv4bwpbqrpsmpqqr59b?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/gw1nnyowxw8bioc5bufj?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/q5bi7tzjbl9hu980ekxg?_a=BAMCkGOa0",



 ],

 "fono-101": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/lw8ubquoi6fnb9ams8dm?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/b5e52xyu6rumoaldut9w?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/xbbrnuuapwodlea7vj6g?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/nueq3qhrhio5njo4pjz9?_a=BAMCkGOa0",



 ],

 "gorro-101": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/emwsgt5r46p1dtae7jxm?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/rtumywjy0krwhwvlgewo?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/ljsoti35viie5obbk77q?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/djwseg8d0nbl2bk6opiu?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/unpc3sitqnlx53qxrjoa?_a=BAMCkGOa0",


 ],

 "gorro-102": [
 "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/xssw2uvg7fq96ab6v4fz?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/wxei3jyd0o8lomxlwbce?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/qtnghley3jrznbut9moc?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/yacrifosrsdcbryzlnvo?_a=BAMCkGOa0",

 ],

 "gorro-103": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/tguqedliyf2gjh4u3exo?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/yo3lsru5nugg7haapbhu?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/shgne3ybeq3bmltm9m5o?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/afpxt4ryj4e1pafiphrl?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/z3yupyra3pgke6utu63o?_a=BAMCkGOa0",
 ],

 "gorro-104": [
 "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/r7civupirv05wnkx5ft6?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/lwvmdigb7c515yh7dflr?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/tzzfbqpbtr98qq3e95ve?_a=BAMCkGOa0",


 ],

 "gorro-105": [
 "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/op8tv8wxon1fhe7tutij?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/d1popkky2pooecd0rhmt?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/m90qrfnwrt2o0pqdgr3p?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/fl0whihb4i6znbywzl4f?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/dnnxdvij2seyg8aqcd55?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/uqpk9nt629os2bpcwux2?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/fabwxbzxyzekzv3nkpor?_a=BAMCkGOa0",


 ],

 "kit-piezas-101": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/lrl1gff7xxkukuxl6ywl?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/lvtdcwaymibbrypltwth?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/m28dzth0ydmctu4ucerz?_a=BAMCkGOa0",

 ],

 "gorro-106": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/txxaq4fkbcndomrlvrby?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/ws2mp9hjqiuyhma7w4xv?_a=BAMCkGOa0",

 ],

 "mochila-101": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/ipdostvdkpy5uocqs942?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/tvylkflnffboye2nqnta?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/qiduvv9ckki5xgv5f6lb?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/vjvyivno3xj55wskocei?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/xvsnidz6jkgkbapos9mt?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/wxx8ongd8kaffppitwhu?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/z30tw9nthv6l1rn4itkj?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/fchwpjvzwn21pld7agre?_a=BAMCkGOa0",


 ],

 "muneca-102": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/eyyh8j3c5v6bnwrgnkmf?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/ceunfnksfxfs9kbhzawf?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/gbv9r9ypbq0oqbhlxg45?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/kjoaaqshb21uhodrjjro?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/fik4syarpwc45lwutjcn?_a=BAMCkGOa0",

 ],
 "muneca-101": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/cas9kfrcmhv1nuotjqu3?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/olj0dixi5fobsu6y9l1z?_a=BAMCkGOa0",


 ],
 "paquete-de-hielo-facial-101": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/rnhd41l2uz3uohrexlmx?_a=BAMCkGOa0",


 ],
 "medias-101": [
"https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/uzcgizubo87nwtjdkult?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/anqkysa4ottqraoyx5fv?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/ie7slg12clygrcmqzjuc?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/eihzvkboq2idecxj33mr?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/ibbur1xkvkw4ykjqbqpe?_a=BAMCkGOa0",




 ],
 "llavero-101": [
"https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/zwet4m0u6o019ezwrmfv?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/v0hnarsqdv5i9fke5rdg?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/jyauvjn7dcei3ih7yrxf?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/jou0xgnu5yrgy5x7fdfs?_a=BAMCkGOa0",

 ],
 "llavero-102": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/zzmqdti7clgouhbagxlc?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/tyvebw7yguib5kduvtel?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/ysalgpfsxkbwvk1g5qyr?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/djtnfkkmev9z6go2vkte?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/gogdacdqcdoxfydlqrcq?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/gogdacdqcdoxfydlqrcq?_a=BAMCkGOa0",

 ],
 "boligrafo-102": [
 "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/uo2pg6ikenhcf10mdffh?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/jo379hicqqqr0e3az35c?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/p0wedaivsauzg2sn6xly?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/al7e3hp7wjw06nf7a67p?_a=BAMCkGOa0",
 ],
 "zuecos-mujer-101": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/lanvq0ei7dukagqrqaps?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/wtnmuk46xqqhfsqxzq2h?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/zsmkrd6uy2gh8vxvhciq?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/u6s70ptccw1uyw1tusju?_a=BAMCkGOa0"
 ],
 "torniquete-ewinever-101": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/snmlyxkwqnw75zvli9tz?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/imub3ss6xggxmkrm9lju?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/rqjqsdptib2a86o88svd?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/fpubki687ea2mtkfv0aj?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/ftuopgprwxbvhqutsz61?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/e2vqrl7mslkidvpk1xx7?_a=BAMCkGOa0",

 ],
 "tobillera-101": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/cpuwobemcf2rrvoil046?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/d1dekozium3zyfiloe8f?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/kfyqskzhysc9amqzcppc?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/lik7znhebzsjcaxxnf29?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/drtvn4syvrumu8vuthmg?_a=BAMCkGOa0",


 ],
 "tirillas-prodigy-50-101": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/tqit9fjcpnu0yaerkgco?_a=BAMCkGOa0",


 ],
 "tirillas-easytouch-50-101": [
"https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/ogtgqosofcczgdnpre7y?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/y7e71salxcazwgwfvz4n?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/ely7vjkwl2wcr2jzd5va?_a=BAMCkGOa0",


 ],
 "tirillas-true-metrix-50-101": [
"https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/jazmdzgpzywenjm45is8?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/lczhy9iuhbzgb50fnqpc?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/dknliwreynk3a2sapz6k?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/rbyqob0cwrzsxon4rfqb?_a=BAMCkGOa0",



 ],
 "tijeras-trauma-101": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/d136shfumxczlwgtrrdp?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/i1ttxqh4srb0cgh8kapk?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/lvdf1wpshmc4ugy1gpnw?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/mmkwkm5q5d9mhvypk1on?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/bz9lue3x127ldhlbsp01?_a=BAMCkGOa0",
 ],
 "termometro-digital-oido-101": [
   "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/lovw55z4sddnlsd0l49q?_a=BAMCkGOa0",
 "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/clmjmysah5hayhxjjeih?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/fds5lbxd2tfdixdsiati?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/fjuwaajj3esnbxngwtky?_a=BAMCkGOa0",


 ],

 "termometro-mercurio-101": [
"https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/ijvmgkonlcjjayn4v1qp?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/vrklg87xog06bse4wjzc?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/lmxzkvkuk8ehwfppcr7u?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/ozl7azlnbzis0d7wol8i?_a=BAMCkGOa0",



 ],
 "resaltador-jeringuilla-101": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/z5ykxj4gqujjo67ouunh?_a=BAMCkGOa0",



 ],
 "rodillera-bisagra-101": [
"https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/kzmtm1vrjotsx3f2qseh?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/sbqfa87esg3skst9myjz?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/xtlkt2scnjnd3wpqbuia?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/inmxmnfzxpp660vc0zcj?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/wckrz4p5rs5ezlzqkawm?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/aj8y7hoekiuwkj0ysbwo?_a=BAMCkGOa0",



 ],
 "rodillera-profesional-101": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/mav0d1dqht9eksec3p1m?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/n5pnyzzaxcpo6ovyemtl?_a=BAMCkGOa0",




 ],
 "pulso-oximetro-pediatrico-101": [
"https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/bpfroylcfihorm4yf6gr?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/x0s9jwgimuv4ouild9fw?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/lvsrufvhv95wjounrima?_a=BAMCkGOa0",
 ],
 
 "pulso-oximetro-imdk-101": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/ct2fembv07h4bppl7jvw?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/qqc0l9ketm0hb5eutt5y?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/yxntaidydeja5bjj7nwu?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/zff9bw7v5da7wjzddjnj?_a=BAMCkGOa0",
 ],
 "pulso-oximetro-blv-101": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/daykcdpdkf3ykbiwzs8b?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/gsopewwku4tu26n4wuxv?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/vnppdk5pzopi4mvcj0eb?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/gcodel4ulgnv3feef3zz?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/m1poclbtif57u6jf66v5?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/m2ftjgv526vepqgzofex?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/vafc3eja8buiqfxdljht?_a=BAMCkGOa0",

 ],
 
 "porta-carnet-stich-101": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/oj0it8ipzpy3uocnd1bu?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/zyx44inovtllb9oemuah?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/gwwqfxvojy6xjd32naft?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/j3w67k4sowgixupcd8zq?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/tlco9svgmdifipnjrngx?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/zqznp7mlexw1iuae6pi5?_a=BAMCkGOa0",


 ],
 "porta-carnet-med-101": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/vpjnszxpxx5oulqmswig?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/ffzus9rbza1rftdphson?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/g6nlym4ftbzu6v5nnrxk?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/h0qff4dinpvq2zjttjwa?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/klw61rdvd5ebcqnbvohp?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/sndy6a6c8poxnwpjh75k?_a=BAMCkGOa0",


 ],
 "porta-carnet-grey-anatomy-101": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/vgll4hgfptmwxna26hjb?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/ye6xbdqfhlf5gxi0wnil?_a=BAMCkGOa0",


 ],
 "porta-carnet-harry-potter-101": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/ket1wihfddti1aeqgwvk?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/wkeu9liuxglqvdhgl0cf?_a=BAMCkGOa0",



 ],
 "porta-carnet-azul-101": [
 "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/amu7yl7hvgoxlwn9t6rh?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/vbbltqc3l1rif0ss8je0?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/pj50xesjwoay5fb8gpuj?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/twwr96oazotz2esvcyol?_a=BAMCkGOa0",



 ],
 "porta-carnet-101": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/oruzkgfkpzarupmimz5l?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/asdb578sduyz7c5x7g0g?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/oznd5kifhps7fqqsfn25?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/at7fsadug0fhrfkqmqgu?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/i13o8nxywfhgffqdgneo?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/i13o8nxywfhgffqdgneo?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/itfhcv74sm8zim77q8x9?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/tp95gzunuevnzfhfar0e?_a=BAMCkGOa0",



 ],
 "plantillas-resistentes-para-aliviar-el-dolor-101": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/wdbvb0gzsgm8ifwoj12t?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/oyhsnjg9v31ant1tymth?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/o1hjiswavi1rcbo53grw?_a=BAMCkGOa0",



 ],
 "pin-pulmon-101": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/xumcd2a0mubm2oc7lrdd?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/xveyjnqri3havldfuzgp?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/oinyfkb85itxhc4pdcwb?_a=BAMCkGOa0",

 ],
 "pin-logo-uasd-101": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/vq2g5d6de3rdhpdvgik0?_a=BAMCkGOa0",

 ],
 "pines-organos-humano-101": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/fyywwxngb8pfa0qq9abo?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/pxakib2auhphiyrgohrc?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/e945ixjw53223w467sno?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/ffasiehd4oq4e3gwigdv?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/wcnhnf8myd84yab4aksl?_a=BAMCkGOa0",



 ],
 "pines-esmaltados-101": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/baol3a1q6bsut2q8oyk6?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/nlqumr8drrctfrwrf43c?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/wl7ugtexzwpnb0xzoipo?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/yi89zianzqyiivrihm7h?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/ov4qm4di22vqtjlve8xx?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/agekuifs95os2ia0vbgy?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/ljr0efgrkjxbqxd8fr4r?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/vbwgzdka4zycxyu5twqg?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/hdaawtnvmwnwjue4uyee?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/wxcph0yokvldxkigypfg?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/oixcakizpaxkfosmxh1j?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/iecr7x6gxn1vxnviushv?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/xp6p3dyukf5xf5alumch?_a=BAMCkGOa0",




 ],
 "pin-ojo-101": [
"https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/s7xdpckggs48mdubmws8?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/cazoekrsbfo6xmf3vxgq?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/jpoquj5yqn8jvtuhzui0?_a=BAMCkGOa0",




 ],
 "pin-estetoscopio-101": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/kph7stlfvawooh2gcofh?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/w3tasrfsuzprzgv6tpfi?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/vr52epxtwd9hgfnk8j5n?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/lwc7muulakf0obboek9q?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/rspaobuvofvb5dv11kse?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/mzuvalgrzk1inbjxcomu?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/sivznhtauapgsatrrri8?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/bymy3ruyg146mwdz0sy0?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/xj2vljjpaayk5sa6prb5?_a=BAMCkGOa0",




 ],
 "pin-de-estetoscopio-101": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/kph7stlfvawooh2gcofh?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/w3tasrfsuzprzgv6tpfi?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/vr52epxtwd9hgfnk8j5n?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/lwc7muulakf0obboek9q?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/rspaobuvofvb5dv11kse?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/mzuvalgrzk1inbjxcomu?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/sivznhtauapgsatrrri8?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/bymy3ruyg146mwdz0sy0?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/xj2vljjpaayk5sa6prb5?_a=BAMCkGOa0",




 ],
 "pin-corazon-rojo-101": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/oenhftt4ushx23qmve9g?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/ofmyz3ayzjrbgkfj7ovg?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/wy662ub3nakzzuvzixsv?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/ndwvi75myig4io2jx6am?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/wy6rw9rc2afwwtlc7q40?_a=BAMCkGOa0",



 ],
 "pin-corazon-humano-101": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/l7lncsrip2fzjvcxhpjh?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/dkuskle3ippjay2ic2jj?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/x2tn1nf71jvzp2mlfr6r?_a=BAMCkGOa0",



 ],
 "pin-corazon-101": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/ydoevuxeuywk9zoiuflu?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/nfeyrexysfqooz7eyt1s?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/llzuyszbbjae04tkcijz?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/zn5bw939dh3l6dyafuc3?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/lamtaquwimg3yx7y6pp3?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/nfyuyxrheibrnec1kwh6?_a=BAMCkGOa0",
 ],
 "soporte-cuello-101": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/c3irineuj2ktbmnknuqv?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/e2lpc7gsn27hj2hexbea?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/y9pulpnw3wrh6xte5h2f?_a=BAMCkGOa0",

 ],
 "termometro-sin-contacto-101": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/z77vsu927n7ve2vfrzo3?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/t8ay5qjisr7h6jat7wa2?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/a9pz6ea4kku6i0zoxtt6?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/oidqhktoophb56yrse7i?_a=BAMCkGOa0",

 ],

 "termometro-digital-101": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/khopu6g3odx1d34aiw0x?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/eb8mqhcofg0ipf91dxkj?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/tekauu3jobxwb9oay8za?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/wrz2iozeigrkyeld3jca?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/ijhzyzj1wev5vyrpvjm1?_a=BAMCkGOa0",



 ],
 "glucometro-easy-touch-101": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/n0n3iier3bxgglof6lib?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/lmzyti2znhplhhe942ev?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/p8x8qnhr2iihaxtkkaon?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/q6oexfpa0pp9krkd6nww?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/nlok1ewojlcz3oixwamz?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/f9hpdftd88z2rl4td4fm?_a=BAMCkGOa0",

 ],
 "pin-caduceo-vara-esculapio-101": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/lsdv9awh4abaa8qplm6w?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/uw8jkftipbgfhxiprzpx?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/z8kado8dqbvvneks3pgp?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/d7rm9rcuxwywrj1gwksn?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/nfwitmt864t6cpwkthy5?_a=BAMCkGOa0",

 
 ],
 "dixie-ems-esfigmomanometro-101": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/idorwzgovx3u45azwtsr?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/eelmqsk1opgo2e4q8oe0?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/ajfb3lbfolnjz2ydlxvr?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/r9iinkur0yen4b9ow9n1?_a=BAMCkGOa0",


 
 ],
 "esfigmomanometro-digital-101": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/nfuvtuag3oor8la9hose?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/j4o3jagd5eilywdulljr?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/idppn2qkdc3tle0uf3pc?_a=BAMCkGOa0",
 ],

 "estetoscopio-doble-tubo-101": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/wepia1a5t5hibbqconnq?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/uuc3tujylhnp7c1fcol9?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/glmtwsuwyx6extzu3jsh?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/btpaiui1upi8uqwxbee6?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/hm7ool9hcceidxo4i4mj?_a=BAMCkGOa0",

 ],
 "estetoscopio-littmann-lightweight-ii-se-101": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/bqauv1umzivmmvrw6mgg?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/n0gqf9wi4697wkmhz6m8?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/zjzqs5xt5m2ukkogkdbg?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/u9avpeo9q5yq0qnwol3z?_a=BAMCkGOa0",

 ],
 "estetoscopio-mdf-procardial-101": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/zsa0i3mnqmbex1inlgmp?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/ko3mvl02dfnkyrhopvjo?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/on8bettent2uxa6et9zt?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/i0ctf7pnjiqd1z1uvusz?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/krroxofynfdfhz3tcka2?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/t5zf9jsh8zizwlyuqplh?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/ddwvj35gx8hxbwzpbse2?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/y2j4dcmlfmppnuramafi?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/yvjpfrh8htynekxf0pni?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/b0k0lgchzbipavgktnoq?_a=BAMCkGOa0",
 ],

 "estetoscopio-mdf-acoustica-deluxe-101": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/nn1xnlawdhn21kfgd83g?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/ppjzx6ktwxxhgur21h3t?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/s3ofbuvtrw2cyduyb1od?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/slh86qld8x9aztzomla8?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/e5yp9i2ftc49im1xqpcf?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/sjrcctdnnyuyvcti28fh?_a=BAMCkGOa0",

 ],
 "glucometro-true-metrix-101": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/hj3v3tn2ufzrryrrxfmb?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/qkuuzcooza9kmij0iegr?_a=BAMCkGOa0",

 ],
 "esfigmomanometro-welch-allyn-101": [
 "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/vjinr6kr2u5dxfwycp3i?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/mjrud6gkgafnfgrvehoc?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/c0q9nighywsdk5tmruc4?_a=BAMCkGOa0",

 ],
 "esfigmomanometro-101": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/x8l1e1netzogpbdqhuyb?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/aq4xuyznd2qoakumfdqr?_a=BAMCkGOa0",

 ],
 "esfigmomanometro-paramed-101": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/ypyzquremkteggefhnvl?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/kfq77fnn7chpe1j45uju?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/omqmverbgmssiilqfssp?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/bmxl0aczj1bbnlr6thqd?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/pywk22xebrj06hmrwuwi?_a=BAMCkGOa0",

 ],
 "estetoscopio-3m-littmann-classic-iii-101": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/robo6x7ptecynlseqyvn?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/vsvhyis75vwh8vm7ejdv?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/axfufpwavfauiwxjejnv?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/rfkvdtk5rwcgapsywbmi?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/gwxi9y0ml6yrcmtofz9m?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/ymqxfops5g3geooeyb7q?_a=BAMCkGOa0",


 ],
 "glucometro-prodigy-101": [
 "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/tttnhpeyadmolkel55n3?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/zolqneixxi9dhlu4blsg?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/n983avo2ocmz3hb2tvng?_a=BAMCkGOa0",


 ],
 "kit-de-diagnostico-de-7-piezas-101": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/jl1sy3g0gaelhacvorxp?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/o4jhpw1rbf2krjdufla8?_a=BAMCkGOa0",



 ],
 "kit-de-diagnostico-otoscopio-3-en-1-de-alta-calidad-101": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/qwulmrptyprip9ylfx3l?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/djzbpdlknr3ptpy7lxkl?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/fn4pew4eosvop35bbkie?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/skc3usxsaejbidmbz85n?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/tmj7xffy0qikja7vofjj?_a=BAMCkGOa0",



 ],
 "kit-de-sutura-completo-101": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/lofxdrfejyeokygwzmat?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/onlmqn9kclwbtkikgknh?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/sf6dmi7wux9va5cxjnx4?_a=BAMCkGOa0",

 ],
 "kit-de-diagnostico-otoscopio-2-en-1-101": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/tnegjonlsyfwzcvqstfo?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/enivbdsenivezhibzu9i?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/gupagrzovuq57qch9927?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/lew5wkbhz83r0riluhgn?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/jyny80onpleezachcn4o?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/s3noaqbn6f0ikk2dg4ye?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/aax9umzvtrgahxb76tby?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/e1nirlovltbmkw1f4kod?_a=BAMCkGOa0",


 ],
 "mini-doppler-101": [
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/nscejysc1itnmetoebom?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/bkawwxeibbhydygbojxi?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/rbpsvgbvqmgaoiayyalv?_a=BAMCkGOa0",


 ],
 "parches-alivio-dolor-101": [
  
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/gnggwedyfrzmre5gtlz6?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/ja5xhm2ynhe3qkdetgps?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/pqoxdu2kybtv7eyzoj0i?_a=BAMCkGOa0",
  "https://res.cloudinary.com/dxykfpv6b/image/upload/c_fill,f_auto,q_auto/v1/wander/sedydyfxq6vackljk0f6?_a=BAMCkGOa0",

 ],

};

export default imagenes;
